export const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return decodeURIComponent(match[2]);
  return null;
};

export const setCookie = (name: string, value: string, days = 7) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = '; expires=' + date.toUTCString();
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax' + secure;
};

export const deleteCookie = (name: string) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export const syncCookiesToLocalStorage = () => {
  try {
    const cookieAccess = getCookie('secure-auth-access');
    const cookieRefresh = getCookie('secure-auth-refresh');
    
    if (cookieAccess) {
      localStorage.setItem('accessToken', cookieAccess);
    }
    if (cookieRefresh) {
      localStorage.setItem('refreshToken', cookieRefresh);
    }
  } catch (err) {
    console.error('Failed to sync cookies to localStorage:', err);
  }
};

export const syncAuthStateToCookies = (auth: any) => {
  try {
    if (auth && auth.accessToken && auth.refreshToken) {
      setCookie('secure-auth-access', auth.accessToken);
      setCookie('secure-auth-refresh', auth.refreshToken);
    } else if (auth && !auth.accessToken) {
      // If not authenticated, clean up cookies
      deleteCookie('secure-auth-access');
      deleteCookie('secure-auth-refresh');
    }
  } catch (err) {
    console.error('Failed to sync auth state to cookies:', err);
  }
};
